import { Injectable } from '@angular/core';
import { LoggedInUserModel } from '../models/logged-in-user.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { GlobalEventsManagerService } from './global-events-manager.service';
@Injectable({
  providedIn: 'root'
})
export class SecurityService {
    private _token: string;
    private _isLoggedIn: boolean;

    private currentUserSubject: BehaviorSubject<LoggedInUserModel>;
    public currentUser: Observable<LoggedInUserModel>;

    constructor(private _eventsManagerService: GlobalEventsManagerService) {
        this.currentUserSubject = new BehaviorSubject<LoggedInUserModel>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get token(): string {
        let currentUser: LoggedInUserModel = JSON.parse(localStorage.getItem('currentUser'));
        this._token = currentUser && currentUser.token;
        return this._token;
    }

    public get currentUserValue(): LoggedInUserModel {
        return this.currentUserSubject.value;
    }

    public get isLoggedIn(): boolean {
        return this.currentUserValue == null ? false : this.currentUserValue.isLoggedIn;
    }

    saveToLocalStorage(loggedUserModel: LoggedInUserModel) {
        localStorage.setItem('currentUser', JSON.stringify(loggedUserModel));
        this.currentUserSubject.next(loggedUserModel);
    }

    logout() {
        this._eventsManagerService.loggedIn(true);
        localStorage.removeItem('currentUser');

        if (localStorage.getItem('surveyParticipantID') != null) {
            localStorage.removeItem('surveyParticipantID');
        }

        this.currentUserSubject.next(null);
    }

    getCurrentUsername(): string {
        return this.currentUserValue == null ? "" : this.currentUserValue.username;
    }

    getCurrentUserId(): number {
        return this.currentUserValue == null ? 0 : this.currentUserValue.id;
    }

    getCurrentUserOrganizationId(): number {
        return this.currentUserValue == null ? 0 : this.currentUserValue.organizationId;
    }

    getCurrentUserProfileId(): number {
        return this.currentUserValue == null ? 0 : this.currentUserValue.profileId;
    }

    hasAdditionalAccessRight(additionalAccessRightID: number): boolean {
        let additionalAccessRightList: number[] = JSON.parse(localStorage.getItem('accessRights'));

        if (additionalAccessRightList && additionalAccessRightList.length && (additionalAccessRightList.filter(x => x == additionalAccessRightID)[0] != null))
            return true;
        return false;
    }

    hasRole(roleName: string): boolean {
        if (this.currentUserValue.roleName == roleName)
            return true;
        else
            return false;
    }
}
